import React from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Menu,
} from "@material-ui/core";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOffRounded as HighlightOffRoundedIcon,
} from "@material-ui/icons";
import { isEmpty, isString } from "lodash";
import Config from "../../domain/config";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import "./style.css";

const { FIELD_LEVEL } = Config;

const SelectedItemView = ({ value }) => {
  const displayValues =
    isString(value) && !isEmpty(value) ? value.split(",") : [];

  return displayValues.map((element) => (
    <span className="seleted-values">{element}</span>
  ));
};

const CombinedSelectFilterInput = ({ meta, values = {}, onChange }) => {
  const [anchorElement, setAnchorElement] = React.useState(null);
  const [primaryValue, setPrimaryValue] = React.useState("");
  const [secondaryValue, setSecondaryValue] = React.useState("");

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const onChangeSelector = (e, key) => {
    setPrimaryValue({
      ...primaryValue,
      [key]: e.target.checked,
    });
    if (e.target.checked) {
      setSecondaryValue({
        ...secondaryValue,
        [key]: "asc",
      });
    } else {
      setSecondaryValue({
        ...secondaryValue,
        [key]: "",
      });
    }
  };

  const primaryMeta = meta.fields.find(
    (element) => element.fieldLevel === FIELD_LEVEL.primary
  );

  const secondaryMeta = meta.fields.find(
    (element) => element.fieldLevel === FIELD_LEVEL.secondary
  );
  const showMenuDropdown = Boolean(anchorElement);

  React.useEffect(() => {
    onChange({ primaryValue, secondaryValue });
  }, [onChange, primaryValue, secondaryValue]);

  return (
    <Grid container direction="row" className="combined-select-filter-input">
      <Button
        variant="contained"
        size="medium"
        className="outer-action-button"
        startIcon={
          isEmpty(primaryValue) && isEmpty(secondaryValue) ? (
            <AddCircleOutlineIcon />
          ) : (
            <HighlightOffRoundedIcon
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setPrimaryValue("");
                setSecondaryValue("");
              }}
            />
          )
        }
        aria-haspopup="true"
        aria-expanded={showMenuDropdown ? "true" : undefined}
        disableElevation
        onClick={handleClick}
      >
        {meta.fieldName}

        <SelectedItemView value={values[meta.fieldName]} />
      </Button>

      <Menu
        id="simple-menu"
        anchorEl={anchorElement}
        keepMounted
        open={showMenuDropdown}
        onClose={handleClose}
        elevation={2}
        variant="selectedMenu"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "center", horizontal: "left" }}
        PaperProps={{ style: { paddingInline: 8 } }}
        autoFocus
      >
        {primaryMeta.options.map((element) => (
          <Grid
            item
            container
            alignItems="center"
            className="combined-filter-options-menu"
          >
            <Grid item container xs>
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedB"
                    color="primary"
                    checked={primaryValue[element?.value] ?? false}
                    onChange={(e) => onChangeSelector(e, element.value)}
                  />
                }
                label={element.label}
                style={{ fontSize: 14 }}
              />
            </Grid>
            <ToggleButtonGroup
              exclusive
              aria-label="text alignment"
              size="small"
              value={secondaryValue[element?.value]}
              onChange={(e, value) => {
                setSecondaryValue({
                  ...secondaryValue,
                  [element.value]: value,
                });
              }}
            >
              {secondaryMeta.options.map((subElement) => (
                <ToggleButton
                  value={subElement.value}
                  aria-label="left aligned"
                  disabled={!primaryValue[element.value]}
                >
                  {subElement.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
        ))}
      </Menu>
    </Grid>
  );
};

export default CombinedSelectFilterInput;
